import { atom, atomWithDefault } from '~shared/lib/atom-state';

import { checkParentVoucher, getParentVoucherDetail } from '~entities/parent/voucher';

import { IVoucherDetailItem } from './types';

export const hasVoucherAtom = atom<boolean>(false);

export const setHasVoucherAtom = atom<boolean, undefined, Promise<void>>(
  (get) => get(hasVoucherAtom),
  async (_get, set) => {
    const result = await checkParentVoucher();
    set(hasVoucherAtom, result ?? false);
  }
);

export const voucherDetailListAtom = atomWithDefault<IVoucherDetailItem[] | null>((_get) => null);

export const setVoucherDetailListAtom = atom<IVoucherDetailItem[] | null, any, Promise<void>>(
  (get) => get(voucherDetailListAtom),
  async (_get, set, _param: any) => {
    try {
      const res = await getParentVoucherDetail(_param);

      if (!res) {
        set(voucherDetailListAtom, []);
      } else {
        set(voucherDetailListAtom, Array.isArray(res) ? res : [res]);
      }
    } catch (error) {
      console.error('Ошибка при получении данных ваучера:', error);
      set(voucherDetailListAtom, null); // Можно задать null или пустой массив
    }
  }
);
